import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  { path: '/', name: 'Home', component: () => import('@/views/Home.vue') },
  { path: '/authorize', name: 'Authorize', component: () => import('@/views/Authorize.vue') },  
  { path: '/companys', name: 'Companys', component: () => import('@/views/Companys.vue') },
  { path: '/dividends', name: 'Dividends', component: () => import('@/views/Dividends.vue') },
  { path: '/b3marketdata', name: 'B3MarketData', component: () => import('@/views/B3MarketData.vue') },  
  { path: '/orders', name: 'Orders', component: () => import('@/views/Orders.vue') },
  { path: '/options-calculator', name: 'OptionsCalculator', component: () => import('@/views/OptionsCalculator.vue') },
  { path: '/symbol/:symbol', name: 'Symbol', component: () => import('@/views/Symbol.vue') },  
  { path: '/symbols', name: 'Symbols', component: () => import('@/views/Symbols/Symbols.vue') },    
  { path: '/transactions', name: 'Transactions', component: () => import('@/views/Transactions.vue') },
  { path: '/manual-note', name: 'ManualNote', component: () => import('@/views/ManualNote.vue') },
  { path: '/import-note', name: 'ImportNote', component: () => import('@/views/ImportNote.vue') },
  { path: '/brokerage-notes', name: 'BrokerageNotes', component: () => import('@/views/BrokerageNotes.vue') },
  { path: '/brokerage-notes/:id', name: 'BrokerageNoteDetail', component: () => import('@/views/BrokerageNoteDetail.vue') },
  { path: '/unauthorized/:status', name: 'Unauthorized', component: () => import('@/views/Unauthorized.vue') },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
